module.exports = __webpack_public_path__ + "img/updateClient.2e8b8d9c.svg";